import {NEW_API_URL} from '@/config/api';
import axios from 'axios';

let isRefreshing = false;
let refreshQueue: Array<{
  resolve: (t: string) => void;
  reject: (e: any) => void;
}> = [];

export const getAccessToken = (): string | null => {
  return localStorage.getItem('accessToken');
};

export const refreshAccessToken = async (): Promise<string> => {
  if (isRefreshing) {
    return await new Promise((resolve, reject) => {
      refreshQueue.push({resolve, reject});
    });
  }

  isRefreshing = true;
  const refreshToken = localStorage.getItem('refreshToken');

  try {
    const response = await axios.post(
      `${NEW_API_URL}/auth/employee-refresh`,
      {},
      {
        headers: {
          Authorization: `Bearer ${refreshToken}`
        }
      }
    );
    const newAccessToken = response?.data?.accessToken;
    localStorage.setItem('accessToken', newAccessToken);
    localStorage.setItem('refreshToken', response?.data?.refreshToken);

    refreshQueue.forEach((q) => q.resolve(newAccessToken));
    refreshQueue = [];
    return newAccessToken;
  } catch (err) {
    rejectQueue(err);
    throw err;
  } finally {
    isRefreshing = false;
  }
};

const rejectQueue = (err: any) => {
  refreshQueue.forEach((q) => q.reject(err));
  refreshQueue = [];
  throw err;
};
